'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('profile', {
      url: '/profile',
      template: '<profile></profile>',
        authenticate: true
    })
    .state('user-profile', {
      url: '/profile/user/:id',
      template: '<profile></profile>',
        authenticate: true
    })
    .state('invited-user-profile', {
      url: '/profile/user/:id/invited',
      template: '<profile type="invited"></profile>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/user/profile/profile.routes.js